var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"header"},[_vm._v("MadLibs")]),_c('div',{staticStyle:{"text-align":"center"}},[_c('button',{on:{"click":_vm.newMadLib}},[_vm._v(" Let's Start! ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }